<template>
	<div></div>
</template>
<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
<script>
export default {
	mounted() {
		$(function () {
			//상단 검색 버튼 클릭시
			$('.search-menu').click(function () {
				if ($(this).hasClass('active')) {
					$('.search-wrap').stop().slideUp();
					$(this).removeClass('active');
					$('.menu', this).text('검색');
				} else {
					$('.search-wrap').stop().slideDown();
					$(this).addClass('active');
					$('.menu', this).text('취소');
				}
			});
			//탭
			$('.tab-menu li').click(function () {
				$('.tab-menu li').removeClass('active');
				$(this).addClass('active');
			});
			//상태값 안내 모달
			$('.help').click(function () {
				if ($(this).hasClass('active')) {
					$('.state-info').hide();
					$(this).removeClass('active');
				} else {
					$('.state-info').show();
					$(this).addClass('active');
				}
			});
			$('.state-info .close').click(function () {
				$('.state-info').hide();
				$('.help').removeClass('active');
			});
			//기간설정
			$('.range-select a').click(function () {
				$('.range-select a').removeClass('active');
				$(this).addClass('active');
			});
			//동의서 선택
			$('.common-sub-top .select-wrap .select').click(function () {
				if ($(this).hasClass('active')) {
					$('.agree-list .ckbox').hide();
					$(this).removeClass('active');
					$(this).text('선택');
					$('.agree-list .write-wrap').show();
					$('.agree-list .del-wrap').hide();
				} else {
					$('.agree-list .ckbox').show();
					$(this).addClass('active');
					$(this).text('취소');
					$('.agree-list .write-wrap').hide();
					$('.agree-list .del-wrap').show();
				}
			});
			//삭제선택
			// $("input:checkbox[name=agree]").click(function () {
			//   let select = $("input:checkbox[name=agree]:checked").length;
			//   $(".del-wrap .num").text(select);
			// });
			//date picker
		});
	}
};
</script>

<style></style>
